import {
  PREFERENCIAS_STORAGE_KEY
} from './preferencias-constants';

export const loadPreferencesFromStorage = () => {
  try {
    const stored = localStorage.getItem(PREFERENCIAS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const savePreferencesToStorage = prefs => {
  localStorage.setItem(PREFERENCIAS_STORAGE_KEY, JSON.stringify(prefs));
};

export const normalizePreferences = (defaultsArray, storedPrefs) => {
  const normalized = {};
  const stored = storedPrefs || {};

  defaultsArray.forEach(pref => {
    if (Object.prototype.hasOwnProperty.call(stored, pref.key)) {
      normalized[pref.key] = stored[pref.key];
    } else {
      normalized[pref.key] = pref.defaultValue;
    }
  });

  return normalized;
};